<template>
  <div class="add-payment-view">
    <!-- Nagłówek -->
    <div class="page-header">
      <div class="header-content">
        <h3 class="page-title">Dodaj nową płatność</h3>
        <p class="page-subtitle">Wypełnij formularz aby dodać nową płatność do systemu</p>
      </div>
      <router-link to="/payments-due">
        <button class="btn-back">
          ← Powrót do listy
        </button>
      </router-link>
    </div>

    <!-- Formularz -->
    <div class="form-container">
      <form @submit.prevent="addPayment">
        
        <!-- Sekcja kontrahenta -->
        <div class="form-section">
          <h5 class="section-title">
            <span class="section-icon">👤</span>
            Kontrahent
          </h5>
          
          <div class="form-group">
            <label class="form-label">Wybierz kontrahenta *</label>
            <v-select
              v-model="contractor"
              label="label"
              :options="contractors"
              placeholder="Zacznij wpisywać aby wyszukać..."
              class="custom-v-select"
            ></v-select>
            <div v-if="!contractor && formTouched" class="error-message">
              Wybór kontrahenta jest wymagany
            </div>
          </div>
        </div>

        <!-- Sekcja szczegółów płatności -->
        <div class="form-section">
          <h5 class="section-title">
            <span class="section-icon">💳</span>
            Szczegóły płatności
          </h5>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Numer faktury *</label>
              <input
                v-model="invoiceNumber"
                type="text"
                class="form-input"
                placeholder="np. FV/2026/001"
              />
              <div v-if="checkIfExist.length > 0" class="warning-message">
                ⚠️ Faktura o numerze <strong>{{ checkIfExist[0].invoiceNumber }}</strong> już istnieje w systemie
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Kwota *</label>
              <input
                v-model="price"
                type="text"
                class="form-input"
                placeholder="np. 1500.00"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Typ płatności *</label>
              <div class="type-selector">
                <button
                  type="button"
                  class="type-btn"
                  :class="{ 'active': type === 'Nalezności' }"
                  @click="type = 'Nalezności'"
                >
                  <span class="type-icon">📥</span>
                  Należności
                </button>
                <button
                  type="button"
                  class="type-btn"
                  :class="{ 'active': type === 'Koszty' }"
                  @click="type = 'Koszty'"
                >
                  <span class="type-icon">📤</span>
                  Koszty
                </button>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Data płatności *</label>
              <input
                v-model="date"
                type="date"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Uwagi</label>
            <vue-editor v-model="notice" class="editor"></vue-editor>
          </div>
        </div>

        <!-- Sticky footer z przyciskiem -->
        <div class="form-footer">
          <button
            type="submit"
            class="btn-submit"
            :disabled="!contractor || !invoiceNumber || !price || !type || !date"
          >
            <span class="submit-icon">✓</span>
            Dodaj płatność
          </button>
          <router-link to="/payments-due" class="btn-cancel">
            Anuluj
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import router from "../router/index";
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      contractor: "",
      invoiceNumber: "",
      notice: "",
      date: "",
      overview: "",
      price: "",
      type: "",
      formTouched: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "contractors", "payments"]),
    checkIfExist() {
      return this.payments.filter((item) => {
        if (this.invoiceNumber) {
          if (
            item.invoiceNumber.toUpperCase().includes(this.invoiceNumber.toUpperCase())
          ) {
            return true;
          }
        }
      });
    },
  },
  components: {
    VueEditor,
  },
  mounted() {
    // Pobierz kontrahentów jeśli nie są jeszcze załadowani
    if (!this.contractors || this.contractors.length === 0) {
      const limits = this.$store.state.userProfile.limits;
      const limit = (limits && limits.contractors) || 1000;
      this.$store.dispatch("getContractors", { limit });
    }
  },
  methods: {
    addPayment() {
      this.formTouched = true;
      
      if (this.contractor) {
        this.$store
          .dispatch("createPayment", {
            contractor: this.contractor,
            invoiceNumber: this.invoiceNumber,
            date: this.date,
            notice: this.notice,
            price: this.price,
            type: this.type,
          })
          .then(() => {
            this.contractor = "";
            this.price = "";
            this.invoiceNumber = "";
            this.notice = "";
            this.date = "";
            this.type = "";
            this.formTouched = false;
            
            // Toast notification instead of alert
            this.showSuccessToast();
            
            setTimeout(() => {
              router.push("/payments-due");
            }, 1000);
          });
      }
    },
    
    showSuccessToast() {
      // Simple success message - można użyć toast systemu jeśli jest
      const toast = document.createElement('div');
      toast.className = 'success-toast';
      toast.textContent = '✓ Płatność została dodana';
      document.body.appendChild(toast);
      
      setTimeout(() => {
        toast.classList.add('show');
      }, 100);
      
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 300);
      }, 3000);
    },
  },
};
</script>
<style scoped>
.add-payment-view {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* HEADER */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 32px;
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.header-content {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 8px 0;
}

.page-subtitle {
  color: #6c757d;
  font-size: 14px;
  margin: 0;
}

.btn-back {
  padding: 12px 24px;
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.btn-back:hover {
  background: #667eea;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* FORMULARZ */
.form-container {
  max-width: 900px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

form {
  padding: 32px;
  padding-bottom: 100px;
}

.form-section {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 2px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 4px;
}

.form-input {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #adb5bd;
}

/* V-SELECT STYLING */
.custom-v-select {
  width: 100%;
  max-width: none !important;
}

.custom-v-select >>> .vs__dropdown-toggle {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: white;
  min-height: 48px;
  transition: all 0.3s ease;
  width: 100%;
  max-width: none !important;
}

.custom-v-select >>> .vs__dropdown-toggle:hover {
  border-color: #d0d5dd;
}

.custom-v-select.vs--open >>> .vs__dropdown-toggle {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-v-select >>> .vs__selected {
  margin: 2px 4px 2px 0;
  padding: 4px 12px;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: none;
}

.custom-v-select >>> .vs__search {
  padding: 8px 4px;
  margin: 0;
  font-size: 14px;
  border: none;
}

.custom-v-select >>> .vs__search::placeholder {
  color: #adb5bd;
}

.custom-v-select >>> .vs__dropdown-menu {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  margin-top: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.custom-v-select >>> .vs__dropdown-option {
  padding: 12px 16px;
  color: #2c3e50;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}

.custom-v-select >>> .vs__dropdown-option:last-child {
  border-bottom: none;
}

.custom-v-select >>> .vs__dropdown-option--highlight {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #667eea;
}

.custom-v-select >>> .vs__dropdown-option--selected {
  background: linear-gradient(135deg, #e7effe 0%, #dbe4fd 100%);
  color: #667eea;
  font-weight: 600;
}

/* TYPE SELECTOR */
.type-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.type-btn {
  padding: 14px 20px;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.type-btn:hover {
  background: #f8f9fa;
  border-color: #d0d5dd;
  transform: translateY(-2px);
}

.type-btn.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.type-icon {
  font-size: 18px;
}

/* EDITOR */
.editor {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.editor:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* MESSAGES */
.error-message {
  color: #dc3545;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.warning-message {
  padding: 12px 16px;
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  color: #856404;
  font-size: 13px;
  margin-top: 8px;
}

.warning-message strong {
  font-weight: 700;
}

/* FOOTER */
.form-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px 32px;
  box-shadow: 0 -4px 12px rgba(0,0,0,0.08);
  display: flex;
  gap: 12px;
  justify-content: center;
  z-index: 100;
}

.btn-submit {
  padding: 16px 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.btn-submit:active:not(:disabled) {
  transform: translateY(0);
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-icon {
  font-size: 20px;
}

.btn-cancel {
  padding: 16px 32px;
  background: white;
  color: #6c757d;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.btn-cancel:hover {
  background: #f8f9fa;
  border-color: #d0d5dd;
  color: #495057;
}

/* SUCCESS TOAST */
.success-toast {
  position: fixed;
  top: 24px;
  right: 24px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  font-weight: 600;
  font-size: 14px;
  z-index: 9999;
  opacity: 0;
  transform: translateX(100px);
  transition: all 0.3s ease;
}

.success-toast.show {
  opacity: 1;
  transform: translateX(0);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .add-payment-view {
    padding: 12px;
  }

  .page-header {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  form {
    padding: 20px;
    padding-bottom: 120px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .type-selector {
    grid-template-columns: 1fr;
  }

  .form-footer {
    flex-direction: column;
    padding: 16px 20px;
  }

  .btn-submit,
  .btn-cancel {
    width: 100%;
    justify-content: center;
  }
}
</style>
